import React, { useState, useEffect } from "react";
import Header from "../../components/UserHeaer";
import { useNavigate } from 'react-router-dom';
import SevenDayImage from "../../assets/7day.jpg";
import MonthlyImage from "../../assets/monthly.jpg";
import YearlyImage from "../../assets/yearly.jpg";
import Swal from 'sweetalert2';

function Home() {
  const [showPopup, setShowPopup] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const [register, setRegister] = useState([]);
  const navigate = useNavigate();
  let headers = new Headers();
  let url = "https://trototbe.azurewebsites.net/api/Orders/create";
  headers.append('Content-Type', 'application/json');
  const token = localStorage.getItem('Token');

  const fetchOrderData = async (type) => {
    var qrImage = "";
    var price = 0;
    var note = "";      
    switch(type){
      case '7days':
        qrImage = "https://firebasestorage.googleapis.com/v0/b/recipeorganizer-98c9b.appspot.com/o/rooms%2F7day.jpg?alt=media";
        price = 50000;
        note = "weekly premium";
        break;
      case 'monthly':
        qrImage = "https://firebasestorage.googleapis.com/v0/b/recipeorganizer-98c9b.appspot.com/o/rooms%2Fmonthly.jpg?alt=media";
        price = 199000;
        note = "monthly premium";
        break;
      case 'yearly':
        qrImage = "https://firebasestorage.googleapis.com/v0/b/recipeorganizer-98c9b.appspot.com/o/rooms%2Fyearly.jpg?alt=media";
        price = 1490000;
        note = "yearly premium";
        break;
      default:
        break;
    } 
    const res = await fetch(url, { mode: 'cors', method: 'POST', headers: new Headers({
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }), body: JSON.stringify({ "qrImage": qrImage, "price": price, "note": note })});
    if(res.status === 200){
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Đăng ký thành công!',
        showConfirmButton: false,
        timer: 1500
      })
    }else{
      const data = await res.text();
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: data
      })
    }
}

  //popup 1
  const handleSubscribeClick = () => {
    setShowPopup(true);
  };
  const handleCloseClick = () => {
    setShowPopup(false);
  };

  //popup 2
  const handleSubscribeClick2 = () => {
    setShowPopup2(true);
  };
  const handleCloseClick2 = () => {
    setShowPopup2(false);
  };

  //popup 3
  const handleSubscribeClick3 = () => {
    setShowPopup3(true);
  };
  const handleCloseClick3 = () => {
    setShowPopup3(false);
  };

  return (
    <div className="w-full">
      <Header />
      <br></br>
      <section className="mb-20">
        <div className=" w-full h-full flex flex-col text-center text-black p-4">
          <h1 className="text-4xl"><span className="font-Dancing italic text-6xl text-orange-400">TroTot</span></h1>
          <h1 className="text-4xl">Motel for <span className="font-Dancing italic text-6xl text-orange-400">memorable</span> moments in emotions!</h1>
        </div>
        <br></br>
        <div className=" w-full h-full flex flex-col text-center text-black p-4">
          <h1 className="text-4xl"><span className="font-Dancing italic text-6xl text-black">Các gói nâng cấp cho người dùng!</span></h1>
        </div>
        <br></br>
        <br></br>
        <div className="container mx-auto relative z-0">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-1">
            <div className="transform transition-all hover:scale-105 ">
              <div className="bg-white shadow-lg p-5 rounded-lg rounded-tl-[90px] w-full max-w-[352px] mx-auto hover:shadow-2xl transition">
                <h1 className="text-4xl"><span className="font-Dancing italic text-6xl text-black">Hàng tuần</span></h1><br></br>
                <div className="text-md text-label-3"><span class="font-semibold text-label-2">Giảm từ 70.000VND/ tuần.</span>
                  <br></br>
                  Gói 7 ngày của chúng tôi cho phép quyền truy cập
                  <span className="font-semibold text-label-2"> tất cả các tính năng nâng cấp</span>, hỗ trợ cho những người đăng ký ngắn hạn.
                </div>
                <div className="flex w-full flex-col items-start justify-start gap-2 py-4 lc-xl:flex-row lc-xl:items-end lc-xl:justify-between">
                  <div className="flex items-end gap-2">
                    <div className="text-4xl font-semibold text-label-1">50.000 VND</div>
                    <div className="mb-0.5 text-base text-label-2"> / tuần</div>
                  </div>
                </div>
                <button className="rounded items-center whitespace-nowrap focus:outline-none dark:bg-dark-fill-3 
                  dark:hover:bg-dark-fill-2 dark:text-dark-label-2 flex w-full justify-center bg-black py-2 px-4 text-base 
                  font-medium text-white hover:bg-label-1" onClick={handleSubscribeClick}>Đăng ký</button>
              </div>
            </div>
            {/* Pop-up */}
            {showPopup && (
              <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-white p-8 rounded-lg flex flex-col items-center">
                  <img src={SevenDayImage} alt="Popup Image" style={{ maxWidth: "50%", maxHeight: "50%" }} />

                  <div className="mt-4 flex gap-4">
                    <button className="bg-black text-white px-4 py-2 rounded-lg" onClick={handleCloseClick}>Đóng</button>
                    <button className="bg-black text-white px-4 py-2 rounded-lg" onClick={() => fetchOrderData('7days')}>Đã quét mã</button>
                  </div>
                </div>
              </div>
            )}
            <div className="transform transition-all hover:scale-105 ">
              <div className="bg-white shadow-lg p-5 rounded-lg rounded-tl-[90px] w-full max-w-[352px] mx-auto hover:shadow-2xl transition">
                <h1 className="text-4xl"><span className="font-Dancing italic text-6xl text-black">Hàng tháng</span></h1><br></br>
                <div class="text-md text-label-3"><span className="font-semibold text-label-2">Giảm từ 350.000VND/ tháng.</span>
                  <br></br>
                  Gói 
                  <span class="font-semibold text-label-2"> phổ biến nhất</span> được bán với giá 350.000 VND và nay chỉ còn 6.700 VND/ ngày.
                </div>
                <div class="flex w-full flex-col items-start justify-start gap-2 py-4 lc-xl:flex-row lc-xl:items-end lc-xl:justify-between">
                  <div class="flex items-end gap-2">
                    <div class="text-4xl font-semibold text-label-1">199.000 VND</div>
                    <div class="mb-0.5 text-base text-label-2">/ tháng</div>
                  </div>
                </div>
                <button className="rounded items-center whitespace-nowrap focus:outline-none dark:bg-dark-fill-3 
                  dark:hover:bg-dark-fill-2 dark:text-dark-label-2 flex w-full justify-center bg-black py-2 px-4 text-base 
                  font-medium text-white hover:bg-label-1" onClick={handleSubscribeClick2}>Đăng ký</button>
              </div>
            </div>
            {/* Pop-up */}
            {showPopup2 && (
              <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-white p-8 rounded-lg flex flex-col items-center">
                  <img src={MonthlyImage} alt="Popup Image" style={{ maxWidth: "50%", maxHeight: "50%" }} />
                  <div className="mt-4 flex gap-4">
                    <button className="bg-black text-white px-4 py-2 rounded-lg" onClick={handleCloseClick2}>Đóng</button>
                    <button className="bg-black text-white px-4 py-2 rounded-lg" onClick={() => fetchOrderData('monthly')}>Đã quét mã</button>
                  </div>
                </div>
              </div>
            )}
            <div className="transform transition-all hover:scale-105 ">
              <div className="bg-white shadow-lg p-5 rounded-lg rounded-tl-[90px] w-full max-w-[352px] mx-auto hover:shadow-2xl transition">
                <h1 className="text-4xl"><span className="font-Dancing italic text-6xl text-black">Hàng năm</span></h1><br></br>
                <div className="text-md text-label-3"><span className="font-semibold text-label-2">Giảm từ 4.200.000 VND/ năm.</span>
                  <br></br>
                  Gói này tiết kiệm cho bạn hơn 
                  <span className="font-semibold text-label-2"> 37% so với gói tháng</span>, phù hợp cho những người đăng ký dài hạn.
                </div>
                <div className="flex w-full flex-col items-start justify-start gap-2 py-4 lc-xl:flex-row lc-xl:items-end 
                  lc-xl:justify-between">
                  <div className="flex items-end gap-2">
                    <div className="text-4xl font-semibold text-label-1">1.490.000 VND</div>
                    <div className="mb-0.5 text-base text-label-2">/ năm</div>
                  </div>
                </div>
                <button className="rounded items-center whitespace-nowrap focus:outline-none dark:bg-dark-fill-3 
                  dark:hover:bg-dark-fill-2 dark:text-dark-label-2 flex w-full justify-center bg-black py-2 px-4 text-base 
                  font-medium text-white hover:bg-label-1" onClick={handleSubscribeClick3}>Đăng ký</button>
              </div>
            </div>
            {/* Pop-up */}
            {showPopup3 && (
              <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-white p-8 rounded-lg flex flex-col items-center">
                  <img src={YearlyImage} alt="Popup Image" style={{ maxWidth: "50%", maxHeight: "50%" }} />

                  <div className="mt-4 flex gap-4">
                    <button className="bg-black text-white px-4 py-2 rounded-lg" onClick={handleCloseClick3}>Hủy</button>
                    <button className="bg-black text-white px-4 py-2 rounded-lg" onClick={() => fetchOrderData('yearly')}>Đã quét mã</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <br></br>
        <br></br>
        <div className="px-10 flex justify-center">
          <div className="flex flex-1 flex-col items-start gap-3 px-10 py-3">
            <div className="flex items-center gap-2">
              <div className="text-base font-medium text-label-1">Đăng nhiều bài viết</div>
            </div>
            <div className="pl-7 text-base text-label-2">Tài khoản của bạn nổi bật với việc đăng nhiều bài viết đa dạng về nội dung mà không còn bị giới hạn về số lần đăng bài viết.</div>
          </div>

          <div className="flex flex-1 flex-col items-start gap-3 px-10 py-3">
            <div className="flex items-center gap-2">
              <div className="text-base font-medium text-label-1">Ưu tiên hiển thị các bài viết của bạn</div>
            </div>
            <div className="pl-7 text-base text-label-2"> Bài viết của bạn được đặt ưu tiên trong việc hiển thị trên nền tảng, giúp nội dung của bạn được đón nhận rộng rãi và thu hút sự chú ý từ người đọc.</div>
          </div>
        </div>

        <div className="px-10 flex justify-center">
          <div className="flex flex-1 flex-col items-start gap-3 px-10 py-3">
            <div className="flex items-center gap-2">
              <div className="text-base font-medium text-label-1">Ưu tiên duyệt các bài viết của bạn</div>
            </div>
            <div className="pl-7 text-base text-label-2">
              <div>Với tài khoản được kiểm chứng, các bài viết của bạn được ưu tiên trong quá trình duyệt và xét duyệt. Điều này giúp bạn có thể chia sẻ thông tin một cách nhanh chóng và hiệu quả.</div>
            </div>
          </div>

          <div className="flex flex-1 flex-col items-start gap-3 px-10 py-3">
            <div className="flex items-center gap-2">
              <div className="text-base font-medium text-label-1">Tài khoản được kiểm chứng</div>
            </div>
            <div className="pl-7 text-base text-label-2">Tài khoản của bạn đã được xác minh và có độ tin cậy cao. Điều này tạo lòng tin cho người đọc và mở ra cơ hội để bạn gặt hái thành công trong việc chia sẻ kiến thức và kinh nghiệm của mình trên mạng.</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;